import { useQuery } from "@tanstack/react-query";
import { getVisits } from "../api/visits.api";
import { VisitRow } from "../api/visit.type";
import { useUserDetails } from "./useUserDetails";

function useLoadVisits(userId?: string) {
  const { userDetails } = useUserDetails();

  const { data: visits = [], isLoading, error } = useQuery<VisitRow[]>({
    queryKey: ["visits", userId || userDetails?.id],
    queryFn: () => getVisits(userId || userDetails?.id),
  });

  return { visits, isLoading, error };
}

export default useLoadVisits;

